/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { media } from '@atlassian/bitkit-responsive';

export const AdaptiveDropdownItem = styled.div(
  {
    display: 'none',
  },
  media.upToLarge(`
    display: block;
  `)
);
